export const SESSION_KEYS = {
    DATAGRID_SEARCH: 'datagrid_search_',
    DATAGRID_SORT: 'datagrid_sort_',
    DATAGRID_FILTER: 'datagrid_filter_',

    FILTER_TASKS_ONLY_OPENED: 'filter_tasks_only_opened',
    FILTER_TASKS_FOR_CURRENT_USER: 'filter_tasks_for_current_user',
};
